var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 400,
    viewBox: "0 0 302 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M236.502 27.2222C202.98 -17.5878 146.251 1.77956 96.9162 22.6067C36.1964 54.163 31.1365 105.915 33.0339 151.356C34.9314 196.797 55.1684 210.051 33.0339 232.141C7.57824 257.545 -8.75218 288.571 5.00266 308.699C33.037 349.722 78.5742 321.13 118.422 371.62C158.269 422.11 229.111 394.341 250.615 371.62C272.12 348.9 301.215 319.868 301.848 269.377C302.48 218.888 275.084 219.716 259.905 188.791C244.724 157.866 267.06 139.365 270.223 121.694C273.386 104.022 270.025 72.0322 236.502 27.2222Z",
    fill: "white",
    fillOpacity: 0.62,
    style: {
      mixBlendMode: "screen"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob4);
export default __webpack_public_path__ + "static/media/blob4.5dc9593e86db5596a3123a3ab3e6c46f.svg";
export { ForwardRef as ReactComponent };